import React from "react";
import { Chip } from "@mui/material";

const statusConfig = {
  upcoming: { label: "Upcoming" },
  active: { label: "Active" },
  locked: { label: "Locked" },
  completed: { label: "Completed" },
};

const MatchdayStatusBadge = ({ status }) => {
  const config = statusConfig[status] || statusConfig.upcoming;

  return <Chip label={config.label} size="small" variant="outlined" />;
};

export default MatchdayStatusBadge;
